import { ResponsiveContainer, ScatterChart, Scatter, XAxis, YAxis, ZAxis, ReferenceLine, Tooltip, Legend } from "recharts";
import { QUADRANTS, matrixQuadrantKey } from "@/lib/classification";

const ORDER = ["chiave", "sviluppare", "mantenere", "marginali"];

function QTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div style={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12, padding: "6px 9px" }}>
      <div style={{ fontWeight: 700 }}>{p.name}</div>
      <div>Valore {p.y} · Attività {p.x}</div>
      <div style={{ color: QUADRANTS[p.quad].hex, fontWeight: 600 }}>{QUADRANTS[p.quad].label}</div>
    </div>
  );
}

export default function QuadrantChart({ partners = [], height = 320 }) {
  const groups = { chiave: [], sviluppare: [], mantenere: [], marginali: [] };
  partners.forEach((p) => {
    const pr = p.profilazione || {};
    if (!pr.categoria_auto) return;
    const k = matrixQuadrantKey(pr);
    groups[k].push({ x: pr.engagement_score ?? 0, y: pr.potential_score ?? 0, name: p.name, quad: k });
  });
  return (
    <ResponsiveContainer width="100%" height={height} data-testid="quadrant-chart">
      <ScatterChart margin={{ top: 16, right: 20, bottom: 20, left: 0 }}>
        <ReferenceLine x={40} stroke="hsl(var(--border))" strokeWidth={1.5} />
        <ReferenceLine y={40} stroke="hsl(var(--border))" strokeWidth={1.5} />
        <XAxis type="number" dataKey="x" domain={[0, 100]} name="Attività" tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))"
          label={{ value: "Attività (engagement) →", position: "insideBottom", offset: -8, fontSize: 10, fill: "hsl(var(--muted-foreground))" }} />
        <YAxis type="number" dataKey="y" domain={[0, 100]} name="Valore" tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))"
          label={{ value: "Valore (potential) ↑", angle: -90, position: "insideLeft", fontSize: 10, fill: "hsl(var(--muted-foreground))", style: { textAnchor: "middle" } }} />
        <ZAxis range={[45, 45]} />
        <Tooltip content={<QTooltip />} cursor={{ strokeDasharray: "3 3" }} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        {ORDER.map((k) => (
          <Scatter key={k} name={QUADRANTS[k].label} data={groups[k]} fill={QUADRANTS[k].hex} fillOpacity={0.72} />
        ))}
      </ScatterChart>
    </ResponsiveContainer>
  );
}
